import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { ProtocolHDModel } from 'src/app/models/ProtocolHDModel';
import { ProtocolHDService } from 'src/app/services/ProtocolHDService';
import { DoctorsService } from 'src/app/services/DoctorsService';
import { DoctorsModel } from 'src/app/models/DoctorsModel';
import { CompanyModel } from 'src/app/models/CompanyModel';
import { CompanyService } from 'src/app/services/CompanyService';
import { MatDialog } from '@angular/material/dialog';
import { PopuppatientsearchComponent } from '../popuppatientsearch/popuppatientsearch.component';
import { PatientModel } from 'src/app/models/PatientsModel';
import { LocalStorageService } from 'ngx-webstorage';
import { formatDate } from '@angular/common';
import { DemographicModel } from 'src/app/models/DemographicModel';
import { DemographicService } from 'src/app/services/DemographicService';
import Swal from 'sweetalert2';
import { MedicalHistoryModel } from 'src/app/models/MedicalHistoryModel';
import { MedicalHistoryService } from 'src/app/services/MedicalHistoryService';
import { ProtocolDetModel } from 'src/app/models/ProtocolDetModel';
import { SurgicalHistoryModel } from 'src/app/models/SurgicalHistoryModel';
import { SurgicalHistoryService } from 'src/app/services/SurgicalHistoryService';
import { FamilyHistoryModel } from 'src/app/models/FamilyHistoryModel';
import { FamilyHistoryService } from 'src/app/services/FamilyHistoryService';
import { CanserModel } from 'src/app/models/CanserModel';
import { CanserService } from 'src/app/services/CanserService';
import { ItemsModel } from 'src/app/models/ItemsModel';
import { ItemsService } from 'src/app/services/ItemsService';
import { UnitsModel } from 'src/app/models/UnitsModel';
import { UnitsService } from 'src/app/services/UnitsService';
import { CurrentMedicationModel } from 'src/app/models/CurrentMedicationModel';
import { CurrentMedicationService } from 'src/app/services/CurrentMedicationService';
import { PathInvModel } from 'src/app/models/PathInvModel';
import { PathInvService } from 'src/app/services/PathInvSevice';
import { ImageTypeModel, ImgInvModel } from 'src/app/models/ImgInvModel';
import { ImgInvService } from 'src/app/services/ImgInvService';
import { EndoInvModel, EndoTypeModel } from 'src/app/models/EndoInvModel';
import { EndoInvService } from 'src/app/services/EndoInvService';
import { TTTOutCocModule } from 'src/app/models/TTTOutCocModule';
import { TTTOutCocService } from 'src/app/services/TTTOutCocService';
import { DisStartingModel } from 'src/app/models/DisStartingModel';
import { DisStartingService } from 'src/app/services/DisStartingService';
import { GeneralExaminationService } from 'src/app/services/GeneralExaminationService';
import { GeneralExaminationModel } from 'src/app/models/GeneralExaminationModel';
import { FollowUpVisitModel } from 'src/app/models/FollowUpVisitModel';
import { FollowUpVisitService } from 'src/app/services/FollowUpVisitService';
import { Router } from '@angular/router';
import { DrugInteractionModel } from 'src/app/models/DrugInteractionModel';
import { DrugInteractionSevice } from 'src/app/services/DrugInteractionSevice';
import { DomSanitizer } from '@angular/platform-browser';
import { DrugInteractionViewComponent } from '../drug-interaction-view/drug-interaction-view.component';
import { DataBankService } from 'src/app/services/DataBankService';
import { DatabankModel } from 'src/app/models/DataBankModel';
import { ComplainsSearchComponent } from '../complains-search/complains-search.component';
import { ComplainsModel } from 'src/app/models/ComplainsModel';
import {ViewEncapsulation} from '@angular/core';
import { PathologyModel } from 'src/app/models/PathologyModel';
import { PathologyService } from 'src/app/services/PathologyService';
import { DialogZoomComponent } from '../dialog-zoom/dialog-zoom.component';

@Component({
  selector: 'app-medical-record',
  templateUrl: './medical-record.component.html',
  styleUrls: ['./medical-record.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class MedicalRecordComponent implements OnInit {
  radTypeCode = '';
  response1 = '';
  response2 = '';
  response3 = '';
  hormonalType = '';
  prHdCode = '';

  docCode = '';
  docName = '';
  compCode = '1';
  compName = '';
  stage = '';
  grade = '';

  surgry_policy = true;
  radio_policy = true;
  chemo_policy = true;
  hormonal_policy = true;
  others_policy = true;
  FirstVisit = true;

  diagnosis = '';
  pathology_M= '';
  doctorsList: DoctorsModel[] = [];
  companyList: CompanyModel[] = [];
  protocolHD: ProtocolHDModel[] = [];


  paAge = 0;
  cancerID = '';
  patientCode = '';
  patientFName = '';
  gender = '';

  patientCode1 = '';
  menstrual = '';
  yyy = '';
  since = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  contraception = '';
  howlong = 0;
  howlongm = 0;
  marital = '';
  nochildren = '';
  ageoldest = '';
  ageyoungest = '';
  pregnancy = '';
  pregnancydate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  pregnancyno = '';
  pregnancyage = 0;
  smoker = '';
  smokertype = '';
  nopacks = '';
  packsunit = '';
  stype = '';
  sdays = 0;
  ssince = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  drinkingalcohol = 'No';
  others = '';
  mention = '';
////==============  Medical History ==============
  patientcodeM = '' ;
  diabetes = 0 ;
  diabetessince = 0 ;
  diabetesdays = '' ;
  diabetescontrol = '' ;
  hayper = 0 ;
  haypersince = 0 ;
  hayperdays = '' ;
  haypercontrol = '' ;
  hepa = 0 ;
  hepasince = 0 ;
  hepadays = '' ;
  hepacontrol = '' ;
  bilh = 0 ;
  bilhsince = 0 ;
  bilhdays = '' ;
  bilhcontrol = '' ;
  card = 0 ;
  cardsince = 0 ;
  carddays = '' ;
  cardcontrol = '' ;
  auto = 0 ;
  autosince = 0 ;
  autodays = '' ;
  autocontrol = '' ;
  allergy = 0 ;
  allergysince = 0 ;
  allergydays = '' ;
  allergycontrol = '' ;
  othersM = 0 ;
  otherssince = 0 ;
  othersdays = '' ;
  otherscontrol = '' ;
  ////=========== Surgry History ==========================
  operationsname = '' ;
  date = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  surgicaldoctor = '' ;
  tsize = '' ;
  nodalstatus = '' ;
  ps = '' ;
  ////========== Family History ============================
  relativedegree = '' ;
  relation = '' ;
  cancerid = '' ;
  age = '' ;
  ////===================== Current Medication ====================

  cmdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  drugref = '' ;
  drugname = '' ;
  dose = '' ;
  uom = '' ;
  route = '' ;
  duration = '' ;
  gencomplaint = '' ;
  frequancy = '' ;
  cmdate1 = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  cmsource = '' ;
  cmdoctor = '' ;
  compcode = '' ;
  userid = '' ;
  modifieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  ittname = '' ;
  unname = '' ;
////===================pathokogy =========================
pathinvcode = '' ;
pdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
pathinvpathology = '' ;
pathinvtype = '' ;
pathinvsite = '' ;
pathinvhtype = '' ;
pathinvothers = '' ;
pagrade = '' ;
pat = '' ;
pan = '' ;
pathinvcomment = '' ;
pathihc = '' ;
pathimg ;
pdate1 = formatDate(new Date(), 'yyyy-MM-dd', 'en');
////============ Images ===========
imginvcode = '' ;
imginvdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
imginv = '' ;
imginvtype = '' ;
imginvsite = '' ;
imginvgrade = '' ;
imginvn = '' ;
imginvm = '' ;
imginvcomm = '' ;
imginvdate1 = formatDate(new Date(), 'yyyy-MM-dd', 'en');
rowid = 0 ;
getfrom = '' ;
visitdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
source = '' ;
///========================== Endoscopy ==============================
endoinvcode = '' ;
endoinvdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
endoinv = '' ;
endoinvtype = '' ;
endoinvsite = '' ;
endoinvgrade = '' ;
endoinvt = '' ;
endoinvn = '' ;
endoinvcomm = '' ;
endoinvdate1 = formatDate(new Date(), 'yyyy-MM-dd', 'en');
getfromEndo = '' ;
visitdateEndo = formatDate(new Date(), 'yyyy-MM-dd', 'en');
sourceEndo = '' ;
///===========================Out Side Surgery =============================
patcode = '' ;
tttdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
ttttype = '' ;
tttname = '' ;
ttttoxicity = '' ;
tttenddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
tttnumb = '' ;
tttduration_dose = '' ;
tttnotes = '' ;
tttresponse = '' ;
///===========================Out Side Radio =============================
patcodeR = '' ;
tttdateR = formatDate(new Date(), 'yyyy-MM-dd', 'en');
ttttypeR = '' ;
tttnameR = '' ;
ttttoxicityR = '' ;
tttenddateR = formatDate(new Date(), 'yyyy-MM-dd', 'en');
tttnumbR = '' ;
tttduration_doseR = '' ;
tttnotesR = '' ;
tttresponseR = '' ;
///===========================Out Side Chemo =============================
patcodeC = '' ;
tttdateC = formatDate(new Date(), 'yyyy-MM-dd', 'en');
ttttypeC = '' ;
tttnameC = '' ;
ttttoxicityC = '' ;
tttenddateC = formatDate(new Date(), 'yyyy-MM-dd', 'en');
tttnumbC = '' ;
tttduration_doseC = '' ;
tttnotesC = '' ;
tttresponseC = '' ;
///===========================Out Side Chemo =============================
patcodeH = '' ;
tttdateH = formatDate(new Date(), 'yyyy-MM-dd', 'en');
ttttypeH = '' ;
tttnameH = '' ;
ttttoxicityH = '' ;
tttenddateH = formatDate(new Date(), 'yyyy-MM-dd', 'en');
tttnumbH = '' ;
tttduration_doseH = '' ;
tttnotesH = '' ;
tttresponseH = '' ;
///=============================Disies Starting =============================
discode = '' ;
disname = '' ;
///==========================================================================
imageid = '' ;
imagename = '' ;
notes = '' ;
////============================= General Examination ===========================

patientcode = '' ;
examdate =  formatDate(new Date(), 'yyyy-MM-dd', 'en');
gcondition = 'Good' ;
peform = '0' ;
weight = '0' ;
height = '0' ;
s_a = '0' ;
acs_a = '0' ;
temp = '37' ;
pulse = '80' ;
rhythm = 'Regular' ;
rhythms = '' ;
b_p = '120/80' ;
respirationrate = '' ;
headneck = 'Normal' ;
hncolour = 'Normal' ;
hnveins = 'Normal' ;
hnthyroid = 'Normal' ;
hnoralcavity = 'Normal' ;
hnswelling = '' ;
hnswellingsite = '' ;
hnswellingsize = '' ;
hncons = 'Soft' ;
hnmob = 'Fixed' ;
hnmention = '' ;
upperlimbs = 'Normal' ;
ulrswelling = '' ;
ulrswellsite = '' ;
ulrswellsize = '' ;
ulrcon = 'Soft' ;
ulrmob = '' ;
ulroedema = '' ;
ulrothers = '' ;
ullswelling = '' ;
ullswellsite = '' ;
ullswellsize = '' ;
ullcon = 'Soft' ;
ullmob = '' ;
ulloedema = '' ;
ullothers = '' ;
lowerlimbs = 'Normal' ;
llrswelling = '' ;
llrswellsite = '' ;
llrswellsize = '' ;
llrcon = 'Soft' ;
llrmob = '' ;
llroedema = '' ;
llrothers = '' ;
lllswelling = '' ;
lllswellsite = '' ;
lllswellsize = '' ;
lllcon = 'Soft' ;
lllmob = '' ;
llloedema = '' ;
lllothers = '' ;
brest = 'Normal' ;
bright = 'Normal' ;
bleft = 'Normal' ;
chest = 'Normal' ;
chestspes = '' ;
abdomen = 'Normal' ;
abdliver = '' ;
abdspleen = '' ;
abdascities = '' ;
abdothers = '' ;
neurological = 'Normal' ;
neurspec = '' ;
lymphadenopathy = 'Normal' ;
rcervical = '' ;
rcervicallevel = '' ;
rcervicalsize = '' ;
rcervicalcons = '' ;
rcervicalmob = '' ;
lcervical = '' ;
lcervicallevel = '' ;
lcervicalsize = '' ;
lcervicalcons = '' ;
lcervicalmob = '' ;
raxillary = '' ;
raxillarylevel = '' ;
raxillarysize = '' ;
raxillarycons = '' ;
raxillarymob = '' ;
laxillary = '' ;
laxillarylevel = '' ;
laxillarysize = '' ;
laxillarycons = '' ;
laxillarymob = '' ;
ringuinal = '' ;
ringuinalsite = '' ;
ringuinalsize = '' ;
ringuinalcons = '' ;
ringuinalmob = '' ;
linguinal = '' ;
linguinalsite = '' ;
linguinalsize = '' ;
linguinalcons = '' ;
linguinalmob = '' ;
hnnotes = '' ;
ulnotes = '' ;
llnotes = '' ;
brestnotes = '' ;
///======================Follow Up Visits ====================
visverial = 1;
visdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
vistype = '' ;
visservice ='Clinic Visit';
visdiganosis = '' ;
visdoctor = '' ;
vislocation = '1' ;
viscomplaint = '' ;
visreqinvistigation = '' ;
visweight = '' ;
visbp = '' ;
vispuls = '' ;
visexamination = '' ;
visdiseasestatus = '' ;
vissite = '' ;
visstage = '' ;
visgrade = '' ;
vist = '' ;
visn = '' ;
vism = '' ;
visstatus = '' ;
visdecision = '' ;
vistttpolicy = '' ;
visnextdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
visnextaction = '' ;
visnotes = '' ;
vispresenthistory = '' ;
vissurgerytype = '' ;
vissurgerynotes = '' ;
visradiotype = '' ;
visradiodose = '' ;
visradionotes = '' ;
vischemotype = '' ;
vischemocycle = '' ;
vischemonotes = '' ;
vishormonaltype = '' ;
vishormonalduration = '' ;
vishormonalnotes = '' ;
visotherstype = '' ;
id =0;

///---------------------- Drug Interaction ----------------------------------
  divisitserial = 0 ;
  didescription = '' ;
  dinotes = '' ;
  diimage :any ;
  myimage :any;
  imageSrc;
  imageSource: any;

  sellersPermitFile: any;
  sellersPermitString :any;

///====================================================================================

  cancerName =[] ;
  cancerName_1 = '';
  surgeryhistory: SurgicalHistoryModel[] = [];
  familyhistory :FamilyHistoryModel[] = [];
  currentmedication : CurrentMedicationModel[]=[];
  disstarting : DisStartingModel[]=[];

  pathology : PathInvModel[]=[];
  PathologyList:PathologyModel[]=[];
  images : ImgInvModel[]=[];
  imagestype : ImageTypeModel[]=[];
  protocols : ProtocolHDModel[]=[];

  endoscopy : EndoInvModel[]=[];
  endotype : EndoTypeModel[]=[];

  sergury :TTTOutCocModule[]=[];
  radiotherapy :TTTOutCocModule[]=[];
  chemotherapy :TTTOutCocModule[]=[];
  hormonal :TTTOutCocModule[]=[];

  itemsList2: ItemsModel[] =[];
  unitsList: UnitsModel[] = [];

  cancerList: CanserModel[] =[];
  MHColor = 'rgb(3, 0, 98)';
  MHColor1 = 'rgb(3, 0, 98)';
  MHColor2 = 'rgb(3, 0, 98)';
  MHColor3 = 'rgb(3, 0, 98)';
  MHColor4 = 'rgb(3, 0, 98)';
  MHColor5 = 'rgb(3, 0, 98)';
  MHColor6 = 'rgb(3, 0, 98)';
  MHColor7 = 'rgb(3, 0, 98)';
  @Output() submitClicked = new EventEmitter<any>();
  ReportURL0 =  'CocReports/PersonalData';
  ReportURL1 =  'CocReports/Prescription';
  constructor(public protocolHDService: ProtocolHDService,
    public ProtocolHD: ProtocolHDModel,
    public doctorsService: DoctorsService,
    public companyService: CompanyService,
    private dialogref: MatDialog,
    public patientsSelectedData: PatientModel,
    public complainsSelect : ComplainsModel,
    public storage: LocalStorageService,
    public demographic: DemographicModel,
    public demographicService: DemographicService,
    public medicalhistory : MedicalHistoryModel,
    public medicalhistoryService : MedicalHistoryService,
    public shistory : SurgicalHistoryModel,
    public shistoryService : SurgicalHistoryService,
    public fhistory : FamilyHistoryModel,
    public fhistoryService : FamilyHistoryService,
    public canserService :CanserService,
    public itemsService : ItemsService,
    public unitsService : UnitsService,
    public cmedication :CurrentMedicationModel,
    public cmedicationService : CurrentMedicationService,
    public pathinv : PathInvModel,
    public pathinvService : PathInvService,
    public imginv1 : ImgInvModel,
    public imginvService : ImgInvService,
    public imgagetype : ImageTypeModel,
    public endoinv1 : EndoInvModel,
    public endoinvService : EndoInvService,
    public protocol : ProtocolHDModel,
    public protocolService : ProtocolHDService,
    public tttoutcoc1 : TTTOutCocModule,
    public tttoutcocService : TTTOutCocService,
    public disstarting1 : DisStartingModel,
    public disstartingService : DisStartingService,
    public generalexaminationService :GeneralExaminationService,
    public generalexamination : GeneralExaminationModel,
    public followupvisitService : FollowUpVisitService,
    public followupvisit : FollowUpVisitModel,
    public route1 : Router,
    public druginteraction : DrugInteractionModel,
    public druginteractionservice :DrugInteractionSevice,
    public databankservice : DataBankService,
    private sanitizer: DomSanitizer,
    public PathologyService : PathologyService,

    public dataBankModel: DatabankModel,
     ) { }

  ngOnInit(): void {
    //this.compCode = this.storage.retrieve('stgcompCode');
    this.retriveProtocolTop();
    this.retriveDoctorsLookupTop();
    this.retriveCompanyLookupTop();
    this.retriveCancerLookup();
    this.retriveItems();
    this.retriveUnitsLookupTop();
    this.retriveImageTypeLookupTop();
    this.retriveEndoTypeLookupTop();
    this.retriveProtocolsLookupTop();
    this. retrivePathologyLookupTop();


    this.RetriveAll();

  }
  RetrivePatient(){
    this.databankservice.getPatient(this.patientCode,this.storage.retrieve('stgcompCode')).subscribe((data: DatabankModel) => {
      this.patientFName = data.patientFName;
      //this.cancerID = data.cancerID;
      this.pathology_M = data.pathology;
      this.cancerID = data.cancerID;
      this.diagnosis = data.diagnosis;
      this.paAge = Number(data.ageYear);
    }

    )
  }
  retriveProtocolTop() {
    this.protocolHDService.getProtocolHDLookupToop(this.storage.retrieve('stgcompCode')).subscribe((data: ProtocolHDModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.protocolHD[i] = data[i];
      }

    }

    )

  }
  retriveItems(){
    this.itemsService.getItemsLookupTop(this.storage.retrieve('stgcompCode')).subscribe((data: ItemsModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.itemsList2[i] = data[i];
      }

    })
  }
  retriveUnitsLookupTop() {
    this.unitsService
      .getUnitsLookupTop(this.storage.retrieve('stgcompCode'))
      .subscribe((data: UnitsModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.unitsList[i] = data[i];
        }

      });
  }
  ///******************************** Look ups ****************************************
  retriveDoctorsLookupTop() {
    this.doctorsService
      .getDoctorsLookupTopDep(this.storage.retrieve('stgcompCode'), 'Oncology')
      .subscribe((data: DoctorsModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.doctorsList[i] = data[i];
        }

      });
  }
  retriveImageTypeLookupTop() {
    this.imginvService
      .getImageTypeLookupTop()
      .subscribe((data: ImageTypeModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.imagestype[i] = data[i];
        }

      });
  }
  retriveEndoTypeLookupTop() {
    this.endoinvService
      .getEndoTypeLookupTop()
      .subscribe((data: EndoTypeModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.endotype[i] = data[i];
        }

      });
  }
  retriveProtocolsLookupTop() {
    this.protocolService
      .getProtocolHDLookupToop(this.storage.retrieve('stgcompCode'))
      .subscribe((data: ProtocolHDModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.protocols[i] = data[i];
        }

      });
  }
  checkSurgery() {
    this.surgry_policy = false;
    this.radio_policy = true;
    this.chemo_policy = true;
    this.hormonal_policy = true;
    this.others_policy = true;
  }
  checkFirstVisit() {
    if (this.vistype == 'First Visit'){this.FirstVisit= false};
    if (this.vistype != 'First Visit'){this.FirstVisit= true};


  }
  checkRadio() {
    this.surgry_policy = true;
    this.radio_policy = false;
    this.chemo_policy = true;
    this.hormonal_policy = true;
    this.others_policy = true;
  }
  checkChemo() {
    this.surgry_policy = true;
    this.radio_policy = true;
    this.chemo_policy = false;
    this.hormonal_policy = true;
    this.others_policy = true;
  }
  checkHormonal() {
    this.surgry_policy = true;
    this.radio_policy = true;
    this.chemo_policy = true;
    this.hormonal_policy = false;
    this.others_policy = true;
  }
  checkOthers() {
    this.surgry_policy = true;
    this.radio_policy = true;
    this.chemo_policy = true;
    this.hormonal_policy = true;
    this.others_policy = false;
  }
  retriveCompanyLookupTop() {

    this.companyService
      .getLocationLookupTop("this.storage.retrieve('stgcompCode')")
      .subscribe((data: CompanyModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.companyList[i] = data[i];
        }

      });
  }
 retriveCancerLookup() {
    this.canserService
      .getCancerLookupTop()
      .subscribe((data: CanserModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.cancerList[i] = data[i];
        }
        //this.cancerName[] = [];
      });
  }

  openDialog() {
    const dialogRef = this.dialogref.open(PopuppatientsearchComponent, {
      data: {
        dataKey: this.patientsSelectedData,
      },
    });
    dialogRef.afterClosed().subscribe((result) => { });
    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe((result) => {
        this.patientCode = result.patientCode;
        this.patientFName = result.patientFName;
        this.gender = result.gender;
        this.cancerID = result.cancerID;
        this.pathology_M = result.pathology;
        this.cancerID = result.cancerID;
        this.diagnosis = result.diagnosis;
        this.paAge = Number(result.ageYear);
        dialogSubmitSubscription.unsubscribe();
        this.retriveDemographic();
      });
  }
  DialogZoom_Decision(){
    if(this.visdecision != '' && this.visdecision !=null){
      const dialogRef = this.dialogref.open(DialogZoomComponent, {
        data: {
          dataKey: this.patientsSelectedData,
          wk_Data : this.visdecision
        },
      });
      dialogRef.afterClosed().subscribe((result) => { });
      const dialogSubmitSubscription =
        dialogRef.componentInstance.submitClicked.subscribe((result) => {
          dialogSubmitSubscription.unsubscribe();
        });
      }
  }
  DialogZoom_Diagnosis(){
    if(this.diagnosis != '' && this.diagnosis !=null){
    const dialogRef = this.dialogref.open(DialogZoomComponent, {
      data: {
        dataKey: this.patientsSelectedData,
        wk_Data : this.diagnosis
      },


    });
    dialogRef.afterClosed().subscribe((result) => { });
    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe((result) => {
        dialogSubmitSubscription.unsubscribe();
      });
    }
  }
  closeDialog(){
    this.dialogref.closeAll();
  }
  DialogComplains(){
    const dialogRef = this.dialogref.open(ComplainsSearchComponent, {
      data: {
        dataKey: this.complainsSelect,
      },
    });
    dialogRef.afterClosed().subscribe((result) => { });
    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe((result) => {
        this.viscomplaint = this.viscomplaint + result.thname;
        dialogSubmitSubscription.unsubscribe();
      });
  }
  RetriveAll()
  {

    this.retriveDemographic();
    this.retriveMedicalHistory();
    this.retriveSHistory();
    this.retriveFHistory();

    this.retrivePathology();
    this.retriveImages();
    this.retriveEndoscopy();
    this.retriveTTTOutSideSurgery();
    this.retriveTTTOutSideSurgery();
    this.retriveTTTOutSideRadio();
    this.retriveTTTOutSideChemo();
    this.retriveTTTOutSideHormonal();
    this.retriveDisStarting();
    this.retriveFollowUpLastSerial()
    this.retriveDrugInteraction();
    this.RetrivePatient();
  }
  /////////////=========== Retrive pathology Top =======///////
  retrivePathologyLookupTop() {
    this.PathologyService
      .getPathologyCLookupTop(this.compCode)
      .subscribe((data: PathologyModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.PathologyList[i] = data[i];
        }

      });
  }
  /////////////=========== Demographic Data ============////////
  retriveDemographic() {
    this.demographicService.getDemo(this.patientCode, this.compCode)
      .subscribe((data: DemographicModel) => {

        if (data.patientcode == null) {
          this. NewDEmographicData();
          return;
        }
        this.patientCode1 = data.patientcode;
        this.patientCode = data.patientcode;
        this.menstrual = data.menstrual;
        this.yyy = data.yyy;
        this.since = formatDate(data.since, 'yyyy-MM-dd', 'en');
        this.contraception = data.contraception;
        this.howlong = data.howlong;
        this.howlongm = data.howlongm;
        this.marital = data.marital;
        this.nochildren = data.nochildren;
        this.ageoldest = data.ageoldest;
        this.ageyoungest = data.ageyoungest;
        this.pregnancy = data.pregnancy;
        //this.compCode = data.compCode;
        this.pregnancydate = data.pregnancydate;
        this.pregnancyno = data.pregnancyno;
        this.pregnancyage = data.pregnancyage;
        this.smoker = data.smoker;
        this.smokertype = data.smokertype;
        this.nopacks = data.nopacks;
        this.packsunit = data.packsunit;
        this.stype = data.stype;
        this.sdays = data.sdays;
        this.ssince = formatDate(data.ssince, 'yyyy-MM-dd', 'en')
        this.drinkingalcohol = data.drinkingalcohol;
        this.others = data.others;
        this.mention = data.mention;

      }
      );
      this.retriveMedicalHistory();
      this.retriveSHistory();
      this.retriveFHistory();
      this.retriveCMedication();
      this.retrivePathology();
      this.retriveImages();
      this.retriveEndoscopy();
      this.retriveTTTOutSideSurgery();
      this.retriveTTTOutSideRadio();
      this.retriveTTTOutSideChemo();
      this.retriveTTTOutSideHormonal();
      this.retriveDisStarting();
      this.retriveGeneralExamination();
      this.retriveFollowUpLastSerial();

     // this.retriveFollowUp();
  }
  submitDemographic() {
    if (this.patientCode == null || this.patientCode == '') {
      return;
    }
    this.demographic.patientcode = this.patientCode;

    this.demographic.menstrual = this.menstrual;
    this.yyy = '0';
    this.demographic.yyy = this.yyy;
    this.demographic.since = formatDate(this.since, 'yyyy-MM-dd', 'en');
    this.demographic.contraception = this.contraception;
    this.demographic.howlong = this.howlong;
    this.demographic.howlongm = this.howlongm;
    this.demographic.marital = '0';
    this.demographic.nochildren = '0';
    this.demographic.ageoldest = '0';
    this.demographic.ageyoungest = '0';
    this.demographic.pregnancy = this.pregnancy;
    this.pregnancydate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.demographic.pregnancydate = formatDate(this.pregnancydate, 'yyyy-MM-dd', 'en');
    this.demographic.pregnancyno = '0';
    this.demographic.pregnancyage = this.pregnancyage;
    this.demographic.smoker = this.smoker;
    this.demographic.smokertype = this.smokertype;
    this.demographic.nopacks = this.nopacks;
    this.demographic.packsunit = '0';
    this.demographic.stype = '0';
    this.demographic.sdays = this.sdays;
    this.demographic.ssince = formatDate(this.ssince, 'yyyy-MM-dd', 'en');
    this.demographic.drinkingalcohol = this.drinkingalcohol;
    this.demographic.others = '0';
    this.demographic.mention = '0';


    //+ "Ssince :" + this.ssince
    this.demographic.userID = this.storage.retrieve('stguserId');
    this.demographic.modifiedDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.demographic.compCode = this.compCode;

    this.demographicService.AddDemo(this.demographic).subscribe(data => {

    this.mesgSave();

    },

      error => { alert(error);
        console.log("Diom")}


    );

  }
  submitDataBank() {

    if (this.patientCode == null || this.patientCode == '') {
      return;
    }
    this.dataBankModel.dateEntry = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.dataBankModel.birthDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');

    this.dataBankModel.patientCode = this.patientCode;
    this.dataBankModel.diagnosis = this.diagnosis;
    this.dataBankModel.cancerID = this.cancerID;
    this.dataBankModel.pathology = this.pathology_M;

    this.dataBankModel.userID = 'sa';
    this.dataBankModel.compCode =  this.storage.retrieve('stgcompCode');
    this.dataBankModel.modifiedDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.databankservice.UpdatePatient(this.dataBankModel).subscribe(data => {

    this.mesgSave();

    },

      error => { alert(error);
        console.log("Diom")}


    );

  }
  NewDEmographicData() {

    this.menstrual = '';
    this.yyy = '';
    this.since = '2021-01-01';
    this.contraception = '';
    this.howlong = 0;
    this.howlongm = 0;
    this.marital = '';
    this.nochildren = '';
    this.ageoldest = '';
    this.ageyoungest = '';
    this.pregnancy = '';
    this.pregnancydate = '2021-01-01';
    this.pregnancyno = '';
    this.pregnancyage = 0;
    this.smoker = '';
    this.smokertype = '';
    this.nopacks = '';
    this.packsunit = '';
    this.stype = '';
    this.sdays = 0;
    this.ssince = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.drinkingalcohol = 'No';
    this.others = '';
    this.mention = '';
  }
  DeleteDemographicData(){
    this.demographicService.delDemo(this.patientCode, this.compCode).subscribe(
      (data: DemographicModel) => {
        this.patientCode = data.patientcode;
        this.NewDEmographicData();
      }
    );
  }
   /////////////======= Medical History Data ========////////
   retriveMedicalHistory() {
    this.medicalhistoryService.getMHistory(this.patientCode, this.storage.retrieve('stgcompCode'))
      .subscribe((data: MedicalHistoryModel) => {

        if (data.patientcode == null) {
          this. NewMedicalHistoryData();
          return;
        }
        this.patientcodeM = data.patientcode ;
        //this.diabetes = data.diabetes ;
        this.diabetessince = data.diabetessince ;
        if (this.diabetessince >= 1){this.MHColor = 'rgb(212, 5, 5)'}
        if (this.diabetessince == 0){this.MHColor = 'rgb(3, 0, 98)'}
        this.diabetesdays = data.diabetesdays;
        this.diabetescontrol = data.diabetescontrol ;
        //this.hayper = data.hayper;
        this.haypersince = data.haypersince ;
        if (this.haypersince >= 0){this.MHColor1 = 'rgb(212, 5, 5)'}
        if (this.haypersince == 0){this.MHColor1 = 'rgb(3, 0, 98)'}
        this.hayperdays = data.hayperdays;
        this.haypercontrol = data.haypercontrol;
        //this.hepa = data.hepa;
        this.hepasince = data.hepasince ;
        if (this.hepasince >= 0){this.MHColor2 = 'rgb(212, 5, 5)'}
        if (this.hepasince == 0){this.MHColor2 = 'rgb(3, 0, 98)'}
        this.hepadays = data.hepadays ;
        this.hepacontrol = data.hepacontrol;
        //this.bilh = data.bilh ;
        this.bilhsince = data.bilhsince ;
        if (this.bilhsince >= 0){this.MHColor3 = 'rgb(212, 5, 5)'}
        if (this.bilhsince == 0){this.MHColor3 = 'rgb(3, 0, 98)'}

        this.bilhdays = data.bilhdays;
        this.bilhcontrol = data.bilhcontrol ;
       // this.card = data.card ;
        this.cardsince = data.cardsince ;
        if (this.cardsince >= 0){this.MHColor4 = 'rgb(212, 5, 5)'}
        if (this.cardsince == 0){this.MHColor4 = 'rgb(3, 0, 98)'}

        this.carddays = data.carddays ;
        this.cardcontrol = data.cardcontrol ;
       // this.auto = data.auto ;
        this.autosince = data.autosince ;
        if (this.autosince >= 0){this.MHColor5 = 'rgb(212, 5, 5)'}
        if (this.autosince == 0){this.MHColor5 = 'rgb(3, 0, 98)'}

        this.autodays = data.autodays ;
        this.autocontrol = data.autocontrol ;
       // this.allergy = data.allergy ;
        this.allergysince = data.allergysince ;
        if (this.allergysince >= 0){this.MHColor6 = 'rgb(212, 5, 5)'}
        if (this.allergysince == 0){this.MHColor6 = 'rgb(3, 0, 98)'}

        this.allergydays = data.allergydays ;
        this.allergycontrol = data.allergycontrol ;
        //this.othersM = data.others ;
        this.otherssince = data.otherssince ;
        if (this.otherssince >= 0){this.MHColor7 = 'rgb(212, 5, 5)'}
        if (this.otherssince == 0){this.MHColor7 = 'rgb(3, 0, 98)'}

        this.othersdays = data.othersdays ;
        this.otherscontrol = data.otherscontrol;

      }


      );

  }
 NewMedicalHistoryData() {
 this.patientcodeM = '';
 this.diabetes = 0 ;
 this.diabetessince = 0 ;
 this.diabetesdays = '' ;
 this.diabetescontrol = '' ;
 this.hayper = 0 ;
 this.haypersince = 0 ;
 this.hayperdays = '' ;
 this.haypercontrol = '' ;
 this.hepa = 0 ;
 this.hepasince = 0 ;
 this.hepadays = '' ;
 this.hepacontrol = '' ;
 this.bilh = 0 ;
 this.bilhsince = 0 ;
 this.bilhdays = '' ;
 this.bilhcontrol = '' ;
 this.card = 0 ;
 this.cardsince = 0 ;
 this.carddays = '' ;
 this.cardcontrol = '' ;
 this.auto = 0 ;
 this.autosince = 0 ;
 this.autodays = '' ;
 this.autocontrol = '' ;
 this.allergy = 0 ;
 this.allergysince = 0 ;
 this.allergydays = '' ;
 this.allergycontrol = '' ;
 this.othersM = 0 ;
 this.otherssince = 0 ;
 this.othersdays = '' ;
 this.otherscontrol = '' ;
  }
  submitMedicalHistory() {
    if (this.patientCode == null || this.patientCode == '') {
      return;
    }
 this.medicalhistory.patientcode = this.patientCode ;
// this.medicalhistory.diabetes.toString() = this.diabetes ;
 this.medicalhistory.diabetessince = this.diabetessince ;
 this.medicalhistory.diabetesdays = this.diabetesdays ;
 this.medicalhistory.diabetescontrol = this.diabetescontrol ;
 //this.medicalhistory.hayper = this.hayper;
 this.medicalhistory.haypersince = this.haypersince ;
 this.medicalhistory.hayperdays = this.hayperdays ;
 this.medicalhistory.haypercontrol = this.haypercontrol ;
 //this.medicalhistory.hepa = this.hepa ;
 this.medicalhistory.hepasince = this.hepasince ;
 this.medicalhistory.hepadays = this.hepadays ;
 this.medicalhistory.hepacontrol = this.hepacontrol ;
 //this.medicalhistory.bilh = this.bilh ;
 this.medicalhistory.bilhsince = this.bilhsince ;
 this.medicalhistory.bilhdays = this.bilhdays ;
 this.medicalhistory.bilhcontrol = this.bilhcontrol ;
 //this.medicalhistory.card = this.card ;
 this.medicalhistory.cardsince = this.cardsince ;
 this.medicalhistory.carddays = this.carddays ;
 this.medicalhistory.cardcontrol = this.cardcontrol ;
 //this.medicalhistory.auto = this.auto ;
 this.medicalhistory.autosince = this.autosince ;
 this.medicalhistory.autodays = this.autodays ;
 this.medicalhistory.autocontrol = this.autocontrol ;
 //this.medicalhistory.allergy = this.allergy ;
 this.medicalhistory.allergysince = this.allergysince ;
 this.medicalhistory.allergydays = this.allergydays ;
 this.medicalhistory.allergycontrol = this.allergycontrol ;
 //this.medicalhistory.others= this.othersM ;
 this.medicalhistory.otherssince = this.otherssince ;
 this.medicalhistory.othersdays = this.othersdays ;
 this.medicalhistory.otherscontrol = this.otherscontrol ;


    this.medicalhistory.userid = this.storage.retrieve('stguserId');
    this.medicalhistory.modifieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.medicalhistory.compcode = this.storage.retrieve('stgcompCode');

    this.medicalhistoryService.AddMHistory(this.medicalhistory).subscribe(data => {

     // this.mesgSave();

    },

      error => { alert(error); console.log("Diom");}

    );

  }
  DeleteMedicalHistory(){
    this.medicalhistoryService.delMHistory(this.patientCode, this.storage.retrieve('stgcompCode')).subscribe(
      (data: MedicalHistoryModel) => {

        this.NewMedicalHistoryData();
      }
    );
  }
  ////////////========== Surgical History ===========////////
  retriveSHistory()
  {

    this.surgeryhistory = [];
    this.shistoryService
      .getSurgicalHistory(this.patientCode,this.storage.retrieve('stgcompCode'))
      .subscribe((data: SurgicalHistoryModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.surgeryhistory[i] = data[i];
          data[i].date = formatDate(data[i].date, 'yyyy-MM-dd', 'en');
        }
        this.operationsname = '' ;
        this.date = formatDate(new Date(), 'yyyy-MM-dd', 'en');
        this.surgicaldoctor = '' ;
      });
  }
  SelectSurgical(pro: SurgicalHistoryModel) {
    this.date = pro.date;
    this.operationsname = pro.operationsname;
    this.surgicaldoctor = pro.surgicaldoctor;

    this.submitClicked.emit(this.shistory);

  }
  submitSHistory() {
    if (this.patientCode == null || this.patientCode == '') {
      return;
    }
      this.shistory.patientcode = this.patientCode;
      this.shistory.date = formatDate(this.date, 'yyyy-MM-dd', 'en');
      this.shistory.operationsname = this.operationsname;
      this.shistory.surgicaldoctor = this.surgicaldoctor;
      this.shistory.tsize = this.tsize;
      this.shistory.nodalstatus = this.nodalstatus;
      this.shistory.ps = this.ps;
      this.shistory.userid = this.storage.retrieve('stguserId');
      this.shistory.modifieddate = formatDate(new Date(),'yyyy-MM-dd','en'  );
      this.shistory.compcode = this.storage.retrieve('stgcompCode');

      this.shistoryService.AddSurgicalHistory(this.shistory).subscribe(
        (data) => {

          this.mesgSave();
          this.operationsname = '' ;
          this.date = formatDate(new Date(), 'yyyy-MM-dd', 'en');
          this.surgicaldoctor = '' ;
          this.retriveSHistory();
        },
        (error) => {
          alert(error);
        }
      );

  }
  delSHistory_Line() {

    this.shistoryService
      .delSurgicalHistory(
        this.patientCode,
        this.date,
        this.storage.retrieve('stgcompCode')
      )
      .subscribe((data: SurgicalHistoryModel) => {

        this.operationsname = '' ;
        this.date = formatDate(new Date(), 'yyyy-MM-dd', 'en');
        this.surgicaldoctor = '' ;
        this.retriveSHistory();
      });
  }
 ////////////========== Family History ===========////////
  retriveFHistory()
  {
    this.familyhistory = [];
    this.fhistoryService
      .getFamilyHistory(this.patientCode,this.storage.retrieve('stgcompCode'))
      .subscribe((data: FamilyHistoryModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.familyhistory[i] = data[i];

        }
        this.relativedegree = '' ;
        this.relation = '' ;
        this.cancerid = '' ;
        this.age = '' ;

      });
  }
  SelectFamily(fam: FamilyHistoryModel) {
    this.relation = fam.relation;
    this.cancerid = fam.cancerid;
    this.age = fam.age;

    this.submitClicked.emit(this.fhistory);

  }
  submitFHistory() {
    if (this.patientCode == null || this.patientCode == '') {
      return;
    }
    this.fhistory.patientcode = this.patientCode;
    this.fhistory.relativedegree = this.relativedegree;
    this.fhistory.relation = this.relation;
    this.fhistory.cancerid = this.cancerID;
    this.fhistory.age = this.age;
    this.fhistory.userid = this.storage.retrieve('stguserId');
    this.fhistory.modifieddate = formatDate(new Date(),'yyyy-MM-dd','en'  );
    this.fhistory.compcode = this.storage.retrieve('stgcompCode');

    this.fhistoryService.AddFamilyHistory(this.fhistory).subscribe(
      (data) => {


        this.relation = '' ;
        this.cancerid = '' ;
        this.age = '' ;

        this.retriveFHistory();
      },
      (error) => {
        alert(error);
      }
    );
}
  delFHistory_Line() {

  this.fhistoryService
    .delFamilyHistory(
      this.id.toString(),this.storage.retrieve('stgcompCode')).subscribe((data: FamilyHistoryModel) => {

      this.relation = '' ;
      this.cancerid = '';
      this.age = '' ;
      this.retriveFHistory();
    });
  }
////////////========== Current Medication ===========////////
retriveCMedication()
{
  this.currentmedication = [];
  this.cmedicationService
    .getCurrentMedicationAll(this.patientCode,this.visdate,this.storage.retrieve('stgcompCode'))
    .subscribe((data: CurrentMedicationModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.currentmedication[i] = data[i];
      }

      //this.NewDataCurrentMedication();
    });
    this.retriveDrugInteraction();
}
NewDataCurrentMedication(){
  this.drugref = '' ;
  this.drugname = '' ;
  this.dose = '' ;
  this.uom = '' ;
  this.route = '' ;
  this.duration = '' ;
  this.gencomplaint = '' ;
  this.frequancy = '' ;
  this.ittname = '' ;
  this.unname = '' ;

}
SelectCurrent(cur: CurrentMedicationModel) {

  this.drugref = cur.drugref;
  this.drugname = cur.drugname ;
  this.cmdate = cur.cmdate;
  this.dose = cur.dose;
  this.uom = cur.uom ;
  this.route = cur.route ;
  this.duration = cur.duration ;
  this.gencomplaint = cur.gencomplaint ;
  this.frequancy = cur.frequancy ;
  this.ittname = cur.ittname ;
  this.unname = cur.unname ;

  this.submitClicked.emit(this.cmedication);

}
submitCMedication() {
  if (this.patientCode == null || this.patientCode == '') {
    return;
  }
  this.cmedication.patientcode = this.patientCode;

  this.cmedication.cmdate = formatDate(this.visdate, 'yyyy-MM-dd', 'en');
  this.cmedication.drugref = this.drugref ;
  this.cmedication.drugname = this.drugname ;
  this.cmedication.dose =this.dose ;
  this.cmedication.uom = this.uom;
  this.cmedication.route = this.route ;
  this.cmedication.duration = this.duration ;
  this.cmedication.gencomplaint = this.gencomplaint ;
  this.cmedication.frequancy = this.frequancy ;
  this.cmedication.cmdate1 = formatDate(this.cmdate1, 'yyyy-MM-dd', 'en');
  this.cmedication.cmsource = this.vistype ;

  this.cmedication.cmdoctor = this.visdoctor ;
  this.cmedication.userid = this.storage.retrieve('stguserId');
  this.cmedication.modifieddate = formatDate(new Date(),'yyyy-MM-dd','en'  );
  this.cmedication.compcode = this.storage.retrieve('stgcompCode');

  this.cmedicationService.AddCurrentMedication(this.cmedication).subscribe(
    (data) => {

      this.NewDataCurrentMedication();

      this.retriveCMedication();
    },
    (error) => {
      alert(error);
    }
  );
}
delCurrentMedication_Line() {

this.cmedicationService
  .delCurrentMedication(
    this.patientCode,
    this.drugref,
    this.storage.retrieve('stgcompCode')
  )
  .subscribe((data: CurrentMedicationModel) => {
      this.NewDataCurrentMedication();
      this.retriveCMedication();
  });
}
////////////=================== Drug Interaction =========================////////
NewDrugInteractionData()
{

  this.divisitserial = 0 ;
  this.didescription = '' ;
  this.dinotes = '' ;
  this.diimage ='' ;
  this.myimage = '';

}
retriveDrugInteraction()
{

  this.druginteractionservice.getDrugInteraction(this.visverial,this.patientCode ,this.storage.retrieve('stgcompCode'))
  .subscribe((data: DrugInteractionModel) => {

    if (data.divisitserial == null) {
      this. NewDrugInteractionData();
      return;
    }

    this.didescription = data.didescription ;
    this.dinotes = data.dinotes ;
    this.myimage = data.diimage;
    this.sellersPermitString =  data.diimage;
    this.myimage =this.sellersPermitString;
    var kk = this.sellersPermitString;
    this.imageSource = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + this.sellersPermitString);
  }
  );

}
submitDrugInteraction() {

  if (this.divisitserial == null || this.sellersPermitString == null) {
    return;
  }
  this.druginteraction.divisitserial = this.visverial;
  this.druginteraction.patientcode = this.patientCode;
  this.druginteraction.didescription = this.didescription;
  this.druginteraction.dinotes = this.dinotes;

  this.druginteraction.userid = this.storage.retrieve('stguserId');
  this.druginteraction.modifieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  this.druginteraction.compcode = this.storage.retrieve('stgcompCode');
  this.druginteraction.diimage = this.sellersPermitString;
  this.druginteractionservice.Adddruginteraction(this.druginteraction).subscribe(data => {
  },
    error => { alert(error); }

  );
  this.druginteractionservice.AdddruginteractionImage(this.druginteraction).subscribe(data => {
  },
    error => { alert(error); }

  );
}
openDialogViwer(){
  this.storage.store('stgvisverial', this.visverial);
  this.storage.store('stgcpatientCode', this.patientCode);
  const dialogRef = this.dialogref.open(DrugInteractionViewComponent,
    {
      data: {
        dataKey: this.druginteraction
      }
  });
  dialogRef.afterClosed().subscribe(result => {
  });

  const dialogSubmitSubscription =
     dialogRef.componentInstance.submitClicked.subscribe(result => {
      dialogSubmitSubscription.unsubscribe();

    });
}

public picked(event: any) {
  let fileList: FileList = event.target.files;
  if (fileList.length > 0) {
    const file: File = fileList[0];
    this.sellersPermitFile = file;
    this.handleInputChange(file); //turn into base64

  }
  else {
    alert("No file selected");
  }
}
handleInputChange(files: any) {
  var file = files;
  var pattern = /image-*/;
  var reader = new FileReader();
  if (!file.type.match(pattern)) {
    alert('invalid format');
    return;
  }

  reader.onloadend = this._handleReaderLoaded.bind(this);
  reader.readAsDataURL(file);
}
_handleReaderLoaded(e: any) {
  let reader = e.target;
  var base64result = reader.result.substr(reader.result.indexOf(',') + 1);
  this.imageSrc = base64result;
  this.sellersPermitString = base64result;
  this.myimage =this.sellersPermitString;
  var kk = this.sellersPermitString;

  this.imageSource = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + this.sellersPermitString);


}


////////////==================== Invistigations ==========================////////
retrivePathology()
{
  this.pathology = [];
  this.pathinvService
    .getPathInvAll(this.patientCode,this.storage.retrieve('stgcompCode'))
    .subscribe((data: PathInvModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.pathology[i] = data[i];
        data[i].pdate = formatDate(data[i].pdate, 'yyyy-MM-dd', 'en');
      }

      this.NewDataPathology();
    });
}
NewDataPathology(){
  this.pathinvcode = '' ;
  this.pdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  this.pathinvpathology = '' ;
  this.pathinvtype = '' ;
  this.pathinvsite = '' ;
  this.pathinvhtype = '' ;
  this.pathinvothers = '' ;
  this.pagrade = '' ;
  this.pat = '' ;
  this.pan = '' ;
  this.pathinvcomment = '' ;
  this.pathihc = '' ;
  this.pathimg ;
  this.pdate1 = formatDate(new Date(), 'yyyy-MM-dd', 'en');

}
SelectPathology(path: PathInvModel) {
  this.pathinvcode =path.pathinvcode ;
  this.pdate = formatDate(path.pdate, 'yyyy-MM-dd', 'en');
  this.pathinvpathology = path.pathinvpathology ;
  this.pathinvtype = path.pathinvtype ;
  this.pathinvsite = path.pathinvsite ;
  this.pathinvhtype = path.pathinvhtype ;
  this.pathinvothers = path.pathinvothers ;
  this.pagrade = path.pagrade ;
  this.pat = path.pat ;
  this.pan = path.pan ;
  this.pathinvcomment = path.pathinvcomment ;
  this.pathihc = path.pathihc ;
  this.pathimg ='';
  this.pdate1 = formatDate(path.pdate1, 'yyyy-MM-dd', 'en');

  this.submitClicked.emit(this.cmedication);

}
submitPathology() {
  if (this.patientCode == null || this.patientCode == '') {
    return;
  }

  this.pathinv.pathinvcode = this.patientCode ;
  this.pathinv.pdate = formatDate(this.pdate, 'yyyy-MM-dd', 'en');
  this.pathinv.pathinvpathology = this.pathinvpathology ;
  this.pathinv.pathinvtype = this.pathinvtype ;
  this.pathinv.pathinvsite = this.pathinvsite ;
  this.pathinv.pathinvhtype = this.pathinvhtype ;
  this.pathinv.pathinvothers = this.pathinvothers ;
  this.pathinv.pagrade = this.pagrade ;
  this.pathinv.pat = this.pat ;
  this.pathinv.pan = this.pan ;
  this.pathinv.pathinvcomment = this.pathinvcomment ;
  this.pathinv.pathihc = this.pathihc ;

  this.pathinv.pdate1 = formatDate(this.pdate1, 'yyyy-MM-dd', 'en');

  this.pathinv.userid = this.storage.retrieve('stguserId');
  this.pathinv.modifieddate = formatDate(new Date(),'yyyy-MM-dd','en'  );
  this.pathinv.compcode = this.storage.retrieve('stgcompCode');

  this.pathinvService.AddPathInv(this.pathinv).subscribe(
    (data) => {

      this.NewDataPathology();

      this.retrivePathology();
    },
    (error) => {
      alert(error);
    }
  );
}
delPathology_Line() {

this.pathinvService
  .delPathInv_Line(
    this.patientCode,
    this.pdate,
    this.storage.retrieve('stgcompCode')
  )
  .subscribe((data: PathInvModel) => {
      this.NewDataPathology();
      this.retrivePathology();
  });
}
/////--------------------------------------------------------------------
retriveImages()
{
  this.images = [];
  this.imginvService
    .getImgInvAll(this.patientCode,this.storage.retrieve('stgcompCode'))
    .subscribe((data: ImgInvModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.images[i] = data[i];
        data[i].imginvdate = formatDate(data[i].imginvdate, 'yyyy-MM-dd', 'en');
      }

      this.NewDataImages();
    });
}
NewDataImages(){
this.imginvcode = '' ;
this.imginvdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
this.imginv = '' ;
this.imginvtype = '' ;
this.imginvsite = '' ;
this.imginvgrade = '' ;
this.imginvn = '' ;
this.imginvm = '' ;
this.imginvcomm = '' ;
this.imginvdate1 = formatDate(new Date(), 'yyyy-MM-dd', 'en');
this.rowid = 0 ;
this.getfrom = '' ;
this.visitdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
this.source = '' ;

}
SelectImages(img: ImgInvModel) {
this.imginvcode = img.imginvcode ;
this.imginvdate = formatDate(img.imginvdate, 'yyyy-MM-dd', 'en');
this.imginv = img.imginv ;
this.imginvtype = img.imginvtype ;
this.imginvsite = img.imginvsite ;
this.imginvgrade = img.imginvgrade ;
this.imginvn = img.imginvn ;
this.imginvm = img.imginvm ;
this.imginvcomm = img.imginvcomm ;
this.imginvdate1 = formatDate(img.imginvdate1, 'yyyy-MM-dd', 'en');

this.getfrom = img.getfrom ;
this.visitdate = formatDate(img.visitdate, 'yyyy-MM-dd', 'en');
this.source = img.source ;



  this.submitClicked.emit(this.images);

}
submitImages() {
  if (this.patientCode == null || this.patientCode == '') {
    return;
  }

  this.imginv1.imginvcode = this.patientCode ;
  this.imginv1.imginvdate = formatDate(this.imginvdate, 'yyyy-MM-dd', 'en');
  this.imginv1.imginv = this.imginv ;
  this.imginv1.imginvtype = this.imginvtype ;
  this.imginv1.imginvsite = this.imginvsite ;
  this.imginv1.imginvgrade = this.imginvgrade ;
  this.imginv1.imginvn = this.imginvn ;
  this.imginv1.imginvm = this.imginvm ;
  this.imginv1.imginvcomm = this.imginvcomm ;
  this.imginv1.imginvdate1 = formatDate(this.imginvdate1, 'yyyy-MM-dd', 'en');
  this.imginv1.getfrom = this.getfrom ;

  this.imginv1.visitdate = formatDate(this.visitdate, 'yyyy-MM-dd', 'en');
  this.imginv1.source = this.source ;
  this.imginv1.userid = this.storage.retrieve('stguserId');
  this.imginv1.modifieddate = formatDate(new Date(),'yyyy-MM-dd','en'  );
  this.imginv1.compcode = this.storage.retrieve('stgcompCode');

  this.imginvService.AddImgInv(this.imginv1).subscribe(
    (data) => {

      this.NewDataImages();

      this.retriveImages();
    },
    (error) => {
      alert(error);
    }
  );
}
delImagesLine() {

this.imginvService
  .delImgInv_Line(
    this.patientCode,
    this.imginvdate,
    this.imginvtype,
    this.storage.retrieve('stgcompCode')
  )
  .subscribe((data: ImgInvModel) => {
      this.NewDataImages();
      this.retriveImages();
  });
}
/////--------------------------------------------------------------------
retriveEndoscopy()
{
  this.endoscopy = [];
  this.endoinvService
    .getEndoInvAll(this.patientCode,this.storage.retrieve('stgcompCode'))
    .subscribe((data: EndoInvModel[]) => {
      for (let i = 0; i < data.length; i++) {
        this.endoscopy[i] = data[i];
        data[i].endoinvdate = formatDate(data[i].endoinvdate, 'yyyy-MM-dd', 'en');
      }

      this.NewDataEndoscopy();
    });
}
NewDataEndoscopy(){
  this.endoinvcode = '' ;
  this.endoinvdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  this.endoinv = '' ;
  this.endoinvtype = '' ;
  this.endoinvsite = '' ;
  this.endoinvgrade = '' ;
  this.endoinvt = '' ;
  this.endoinvn = '' ;
  this.endoinvcomm = '' ;
  this.endoinvdate1 = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  this.getfromEndo = '' ;
  this.visitdateEndo = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  this.sourceEndo = '' ;
}
SelectEndoscopy(endo: EndoInvModel) {
this.endoinvcode = endo.endoinvcode ;
this.endoinvdate = formatDate(endo.endoinvdate, 'yyyy-MM-dd', 'en');
this.endoinv = endo.endoinv ;
this.endoinvtype = endo.endoinvtype ;
this.endoinvsite = endo.endoinvsite ;
this.endoinvgrade = endo.endoinvgrade ;
this.endoinvn = endo.endoinvn ;
this.endoinvcomm = endo.endoinvcomm ;
this.endoinvdate1 = formatDate(endo.endoinvdate1, 'yyyy-MM-dd', 'en');

this.getfromEndo = endo.getfrom ;
this.visitdateEndo = formatDate(endo.visitdate, 'yyyy-MM-dd', 'en');
this.sourceEndo = endo.source ;



  this.submitClicked.emit(this.endoscopy);

}
submitEndoscopy() {
  if (this.patientCode == null || this.patientCode == '') {
    return;
  }

  this.endoinv1.endoinvcode = this.patientCode ;
  this.endoinv1.endoinvdate = formatDate(this.endoinvdate, 'yyyy-MM-dd', 'en');
  this.endoinv1.endoinv = this.endoinv ;
  this.endoinv1.endoinvtype = this.endoinvtype ;
  this.endoinv1.endoinvsite = this.endoinvsite ;
  this.endoinv1.endoinvgrade = this.endoinvgrade ;
  this.endoinv1.endoinvn = this.endoinvn ;
  this.endoinv1.endoinvcomm = this.endoinvcomm ;
  this.endoinv1.endoinvdate1 = formatDate(this.endoinvdate1, 'yyyy-MM-dd', 'en');
  this.endoinv1.getfrom = this.getfrom ;

  this.endoinv1.visitdate = formatDate(this.visitdate, 'yyyy-MM-dd', 'en');
  this.endoinv1.source = this.source ;
  this.endoinv1.userid = this.storage.retrieve('stguserId');
  this.endoinv1.modifieddate = formatDate(new Date(),'yyyy-MM-dd','en'  );
  this.endoinv1.compcode = this.storage.retrieve('stgcompCode');

  this.endoinvService.AddEndoInv(this.endoinv1).subscribe(
    (data) => {

      this.NewDataEndoscopy();

      this.retriveEndoscopy();
    },
    (error) => {
      alert(error);
    }
  );
}
delEndoscopyLine() {

this.endoinvService
  .delEndoInv_Line(
    this.patientCode,
    this.endoinvdate,
    this.endoinvtype,
    this.storage.retrieve('stgcompCode')
  )
  .subscribe((data: EndoInvModel) => {
      this.NewDataEndoscopy();
      this.retriveEndoscopy
      ();
  });
}

/////--------------------------------------------------------------------
///***** surgery *****/
retriveTTTOutSideSurgery()
{
  this.sergury = [];
  this.tttoutcocService
    .getTTTOutCocAll(this.patientCode,"Surgery", this.storage.retrieve('stgcompCode'))
    .subscribe((data: TTTOutCocModule[]) => {
      for (let i = 0; i < data.length; i++) {
        this.sergury[i] = data[i];
        data[i].tttdate = formatDate(data[i].tttdate, 'yyyy-MM-dd', 'en');
      }

      this.NewDataEndoscopy();
    });
}
NewDataOutSurgery(){
this.patcode = '' ;
this.tttdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
this.ttttype = '' ;
this.tttname = '' ;
this.ttttoxicity = '' ;
this.tttenddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
this.tttnumb = '' ;
this.tttduration_dose = '' ;
this.tttnotes = '' ;
this.tttresponse = '' ;
}
SelectOutSide(surg: TTTOutCocModule) {

  this.patcode = surg.patcode ;
  this.tttdate = formatDate(surg.tttdate, 'yyyy-MM-dd', 'en');
  this.ttttype = surg.ttttype ;
  this.tttname = surg.tttname ;
  this.ttttoxicity = surg.ttttoxicity ;
  this.tttenddate = formatDate(surg.tttenddate, 'yyyy-MM-dd', 'en');
  this.tttnumb = surg.tttnumb ;
  this.tttduration_dose = surg.tttduration_dose ;
  this.tttnotes = surg.tttnotes ;
  this.tttresponse = surg.tttresponse ;


  this.submitClicked.emit(this.sergury);

}
submitOutSideSurgery() {
  if (this.patientCode == null || this.patientCode == '') {
    return;
  }
  this.tttoutcoc1.patcode = this.patientCode ;
  this.tttoutcoc1.tttdate = formatDate(this.tttdate, 'yyyy-MM-dd', 'en');
  this.tttoutcoc1.ttttype = 'Surgery';
  this.tttoutcoc1.tttname = this.tttname ;
  this.tttoutcoc1.ttttoxicity = this.ttttoxicity ;
  this.tttoutcoc1.tttenddate = formatDate(this.tttenddate, 'yyyy-MM-dd', 'en');
  this.tttoutcoc1.tttnumb = this.tttnumb ;
  this.tttoutcoc1.tttduration_dose = this.tttduration_dose ;
  this.tttoutcoc1.tttnotes = this.tttnotes ;
  this.tttoutcoc1.tttresponse = this.tttresponse ;

  this.tttoutcoc1.userid = this.storage.retrieve('stguserId');
  this.tttoutcoc1.modifieddate = formatDate(new Date(),'yyyy-MM-dd','en'  );
  this.tttoutcoc1.compcode = this.storage.retrieve('stgcompCode');

  this.tttoutcocService.AddTTTOutCoc(this.tttoutcoc1).subscribe(
    (data) => {

      this.NewDataOutSurgery();

      this.retriveTTTOutSideSurgery();
    },
    (error) => {
      alert(error);
    }
  );
}
DelOutSideSurgeryLine() {

this.tttoutcocService
  .delTTToutCoc_Line(this.patientCode,this.tttdate,'Surgery', this.tttname,this.storage.retrieve('stgcompCode')
  )
  .subscribe((data: TTTOutCocModule) => {
    this.NewDataOutSurgery();
    this.retriveTTTOutSideSurgery();

  });
}
///***** Radio *****/
retriveTTTOutSideRadio()
{
  this.radiotherapy = [];
  this.tttoutcocService
    .getTTTOutCocAll(this.patientCode,"Radiotherapy", this.storage.retrieve('stgcompCode'))
    .subscribe((data: TTTOutCocModule[]) => {
      for (let i = 0; i < data.length; i++) {
        this.radiotherapy[i] = data[i];
        data[i].tttdate = formatDate(data[i].tttdate, 'yyyy-MM-dd', 'en');
      }

      this.NewDataOutRadio();
    });
}
NewDataOutRadio(){
this.patcodeR = '' ;
this.tttdateR = formatDate(new Date(), 'yyyy-MM-dd', 'en');
this.ttttypeR = '' ;
this.tttnameR = '' ;
this.ttttoxicityR = '' ;
this.tttenddateR = formatDate(new Date(), 'yyyy-MM-dd', 'en');
this.tttnumbR = '' ;
this.tttduration_doseR = '' ;
this.tttnotesR = '' ;
this.tttresponseR = '' ;
}
SelectOutSideR(surg: TTTOutCocModule) {

  this.patcodeR = surg.patcode ;
  this.tttdateR = formatDate(surg.tttdate, 'yyyy-MM-dd', 'en');
  this.ttttypeR = surg.ttttype ;
  this.tttnameR = surg.tttname ;
  this.ttttoxicityR = surg.ttttoxicity ;
  this.tttenddateR = formatDate(surg.tttenddate, 'yyyy-MM-dd', 'en');
  this.tttnumbR = surg.tttnumb ;
  this.tttduration_doseR = surg.tttduration_dose ;
  this.tttnotesR = surg.tttnotes ;
  this.tttresponseR = surg.tttresponse ;


  this.submitClicked.emit(this.radiotherapy);

}
submitOutSideRadio() {
  if (this.patientCode == null || this.patientCode == '') {
    return;
  }
  this.tttoutcoc1.patcode = this.patientCode ;
  this.tttoutcoc1.tttdate = formatDate(this.tttdateR, 'yyyy-MM-dd', 'en');
  this.tttoutcoc1.ttttype = 'Radiotherapy';
  this.tttoutcoc1.tttname = this.tttnameR ;
  this.tttoutcoc1.ttttoxicity = this.ttttoxicityR ;
  this.tttoutcoc1.tttenddate = formatDate(this.tttenddateR, 'yyyy-MM-dd', 'en');
  this.tttoutcoc1.tttnumb = this.tttnumbR ;
  this.tttoutcoc1.tttduration_dose = this.tttduration_doseR ;
  this.tttoutcoc1.tttnotes = this.tttnotesR ;
  this.tttoutcoc1.tttresponse = this.tttresponseR ;

  this.tttoutcoc1.userid = this.storage.retrieve('stguserId');
  this.tttoutcoc1.modifieddate = formatDate(new Date(),'yyyy-MM-dd','en'  );
  this.tttoutcoc1.compcode = this.storage.retrieve('stgcompCode');

  this.tttoutcocService.AddTTTOutCoc(this.tttoutcoc1).subscribe(
    (data) => {

      this.NewDataOutRadio();

      this.retriveTTTOutSideRadio();
    },
    (error) => {
      alert(error);
    }
  );
}
DelOutSideRadioLine() {

this.tttoutcocService
  .delTTToutCoc_Line(this.patientCode,this.tttdateR,'Radiotherapy', this.tttnameR,this.storage.retrieve('stgcompCode'))
  .subscribe((data: TTTOutCocModule) => {
    this.NewDataOutRadio();
    this.retriveTTTOutSideRadio();

  });
}
///***** Chemo *****/
retriveTTTOutSideChemo()
{
  this.chemotherapy = [];
  this.tttoutcocService
    .getTTTOutCocAll(this.patientCode,"Chemotherapy", this.storage.retrieve('stgcompCode'))
    .subscribe((data: TTTOutCocModule[]) => {
      for (let i = 0; i < data.length; i++) {
        this.chemotherapy[i] = data[i];
        data[i].tttdate = formatDate(data[i].tttdate, 'yyyy-MM-dd', 'en');
        data[i].tttenddate = formatDate(data[i].tttenddate, 'yyyy-MM-dd', 'en');
      }

      this.NewDataChemo();
    });
}
NewDataChemo(){
this.patcodeC = '' ;
this.tttdateC = formatDate(new Date(), 'yyyy-MM-dd', 'en');
this.ttttypeC = '' ;
this.tttnameC = '' ;
this.ttttoxicityC = '' ;
this.tttenddateC = formatDate(new Date(), 'yyyy-MM-dd', 'en');
this.tttnumbC = '' ;
this.tttduration_doseC = '' ;
this.tttnotesC = '' ;
this.tttresponseC = '' ;
}
SelectOutSideC(surg: TTTOutCocModule) {

  this.patcodeC = surg.patcode ;
  this.tttdateC = formatDate(surg.tttdate, 'yyyy-MM-dd', 'en');
  this.ttttypeC = surg.ttttype ;
  this.tttnameC = surg.tttname ;
  this.ttttoxicityC = surg.ttttoxicity ;
  this.tttenddateC = formatDate(surg.tttenddate, 'yyyy-MM-dd', 'en');
  this.tttnumbC = surg.tttnumb ;
  this.tttduration_doseC = surg.tttduration_dose ;
  this.tttnotesC = surg.tttnotes ;
  this.tttresponseC = surg.tttresponse ;


  this.submitClicked.emit(this.chemotherapy);

}
submitOutSideChemo() {
  if (this.patientCode == null || this.patientCode == '') {
    return;
  }
  this.tttoutcoc1.patcode = this.patientCode ;
  this.tttoutcoc1.tttdate = formatDate(this.tttdateC, 'yyyy-MM-dd', 'en');
  this.tttoutcoc1.ttttype = 'Chemotherapy';
  this.tttoutcoc1.tttname = this.tttnameC ;
  this.tttoutcoc1.ttttoxicity = this.ttttoxicityC ;
  this.tttoutcoc1.tttenddate = formatDate(this.tttenddateC, 'yyyy-MM-dd', 'en');
  this.tttoutcoc1.tttnumb = this.tttnumbC ;
  this.tttoutcoc1.tttduration_dose = this.tttduration_doseC ;
  this.tttoutcoc1.tttnotes = this.tttnotesC ;
  this.tttoutcoc1.tttresponse = this.tttresponseC ;

  this.tttoutcoc1.userid = this.storage.retrieve('stguserId');
  this.tttoutcoc1.modifieddate = formatDate(new Date(),'yyyy-MM-dd','en'  );
  this.tttoutcoc1.compcode = this.storage.retrieve('stgcompCode');

  this.tttoutcocService.AddTTTOutCoc(this.tttoutcoc1).subscribe(
    (data) => {

      this.NewDataChemo();

      this.retriveTTTOutSideChemo();
    },
    (error) => {
      alert(error);
    }
  );
}
DelOutSideChemoLine() {

this.tttoutcocService
  .delTTToutCoc_Line(this.patientCode,this.tttdateC,'Chemotherapy', this.tttnameC,this.storage.retrieve('stgcompCode'))
  .subscribe((data: TTTOutCocModule) => {
    this.NewDataChemo();
    this.retriveTTTOutSideChemo();

  });
}
///***** Hormonal *****/
retriveTTTOutSideHormonal()
{
  this.hormonal = [];
  this.tttoutcocService
    .getTTTOutCocAll(this.patientCode,"Hormonal", this.storage.retrieve('stgcompCode'))
    .subscribe((data: TTTOutCocModule[]) => {
      for (let i = 0; i < data.length; i++) {
        this.hormonal[i] = data[i];
        data[i].tttdate = formatDate(data[i].tttdate, 'yyyy-MM-dd', 'en');
        data[i].tttenddate = formatDate(data[i].tttenddate, 'yyyy-MM-dd', 'en');
      }

      this.NewDataHormonal();
    });
}
NewDataHormonal(){
this.patcodeH = '' ;
this.tttdateH = formatDate(new Date(), 'yyyy-MM-dd', 'en');
this.ttttypeH = '' ;
this.tttnameH = '' ;
this.ttttoxicityH = '' ;
this.tttenddateH = formatDate(new Date(), 'yyyy-MM-dd', 'en');
this.tttnumbH = '' ;
this.tttduration_doseH = '' ;
this.tttnotesH = '' ;
this.tttresponseH = '' ;
}
SelectOutSideH(surg: TTTOutCocModule) {

  this.patcodeH = surg.patcode ;
  this.tttdateH = formatDate(surg.tttdate, 'yyyy-MM-dd', 'en');
  this.ttttypeH = surg.ttttype ;
  this.tttnameH = surg.tttname ;
  this.ttttoxicityH = surg.ttttoxicity ;
  this.tttenddateH = formatDate(surg.tttenddate, 'yyyy-MM-dd', 'en');
  this.tttnumbH = surg.tttnumb ;
  this.tttduration_doseH = surg.tttduration_dose ;
  this.tttnotesH = surg.tttnotes ;
  this.tttresponseH = surg.tttresponse ;


  this.submitClicked.emit(this.hormonal);

}
submitOutSideHormonal() {
  if (this.patientCode == null || this.patientCode == '') {
    return;
  }
  this.tttoutcoc1.patcode = this.patientCode ;
  this.tttoutcoc1.tttdate = formatDate(this.tttdateH, 'yyyy-MM-dd', 'en');
  this.tttoutcoc1.ttttype = 'Hormonal';
  this.tttoutcoc1.tttname = this.tttnameH ;
  this.tttoutcoc1.ttttoxicity = this.ttttoxicityH ;
  this.tttoutcoc1.tttenddate = formatDate(this.tttenddateH, 'yyyy-MM-dd', 'en');
  this.tttoutcoc1.tttnumb = this.tttnumbH ;
  this.tttoutcoc1.tttduration_dose = this.tttduration_doseH ;
  this.tttoutcoc1.tttnotes = this.tttnotesH ;
  this.tttoutcoc1.tttresponse = this.tttresponseH ;

  this.tttoutcoc1.userid = this.storage.retrieve('stguserId');
  this.tttoutcoc1.modifieddate = formatDate(new Date(),'yyyy-MM-dd','en'  );
  this.tttoutcoc1.compcode = this.storage.retrieve('stgcompCode');

  this.tttoutcocService.AddTTTOutCoc(this.tttoutcoc1).subscribe(
    (data) => {

      this.NewDataChemo();

      this.retriveTTTOutSideHormonal();
    },
    (error) => {
      alert(error);
    }
  );
}
DelOutSideHormonalLine() {

this.tttoutcocService
  .delTTToutCoc_Line(this.patientCode,this.tttdateH,'Hormonal', this.tttnameH,this.storage.retrieve('stgcompCode'))
  .subscribe((data: TTTOutCocModule) => {
    this.NewDataHormonal();
    this.retriveTTTOutSideHormonal();

  });
}
///***** Dis Stsrting *****/
retriveDisStarting()
{

  this.disstartingService
    .getDisStarting(this.patientCode, this.storage.retrieve('stgcompCode'))
    .subscribe((data: DisStartingModel) => {
        this.disname = data.disname
          });
}
NewDataDisStarting(){
  this.discode = '' ;
  this.disname = '' ;

}

submitDisStarting() {
  if(this.disname == '' || this.disname == null){return;}
  this.disstarting1.discode = this.patientCode ;
  this.disstarting1.disname = this.disname;

  this.disstarting1.userid = this.storage.retrieve('stguserId');
  this.disstarting1.modifieddate = formatDate(new Date(),'yyyy-MM-dd','en'  );
  this.disstarting1.compcode = this.storage.retrieve('stgcompCode');

  this.disstartingService.AddDisStarting(this.disstarting1).subscribe(
    (data) => {

      this.retriveDisStarting();
    },
    (error) => {
      alert(error);
      console.log("Distar")
    }
  );
}
////**************** General Examination **********/
NewGeneralExaminationData()
{

this.examdate =  formatDate(new Date(), 'yyyy-MM-dd', 'en');
this.gcondition = 'Good' ;
this.peform = '0' ;
this.weight = '0' ;
this.height = '0' ;
this.s_a = '0' ;
this.acs_a = '0' ;
this.temp = '37' ;
this.pulse = '80' ;
this.rhythm = 'Regular' ;
this.rhythms = '' ;
this.b_p = '120/80' ;
this.respirationrate = '' ;
this.headneck = 'Normal' ;
this.hncolour = 'Normal' ;
this.hnveins = 'Normal' ;
this.hnthyroid = 'Normal' ;
this.hnoralcavity = 'Normal' ;
this.hnswelling = '' ;
this.hnswellingsite = '' ;
this.hnswellingsize = '' ;
this.hncons = 'Soft' ;
this.hnmob = 'Fixed' ;
this.hnmention = '' ;
this.upperlimbs = 'Normal' ;
this.ulrswelling = '' ;
this.ulrswellsite = '' ;
this.ulrswellsize = '' ;
this.ulrcon = 'Soft' ;
this.ulrmob = '' ;
this.ulroedema = '' ;
this.ulrothers = '' ;
this.ullswelling = '' ;
this.ullswellsite = '' ;
this.ullswellsize = '' ;
this.ullcon = 'Soft' ;
this.ullmob = '' ;
this.ulloedema = '' ;
this.ullothers = '' ;
this.lowerlimbs = 'Normal' ;
this.llrswelling = '' ;
this.llrswellsite = '' ;
this.llrswellsize = '' ;
this.llrcon = 'Soft' ;
this.llrmob = '' ;
this.llroedema = '' ;
this.llrothers = '' ;
this.lllswelling = '' ;
this.lllswellsite = '' ;
this.lllswellsize = '' ;
this.lllcon = 'Soft' ;
this.lllmob = '' ;
this.llloedema = '' ;
this.lllothers = '' ;
this.brest = 'Normal' ;
this.bright = 'Normal' ;
this.bleft = 'Normal' ;
this.chest = 'Normal' ;
this.chestspes = '' ;
this.abdomen = 'Normal' ;
this.abdliver = '' ;
this.abdspleen = '' ;
this.abdascities = '' ;
this.abdothers = '' ;
this.neurological = 'Normal' ;
this.neurspec = '' ;
this.lymphadenopathy = 'Normal' ;
this.rcervical = '' ;
this.rcervicallevel = '' ;
this.rcervicalsize = '' ;
this.rcervicalcons = '' ;
this.rcervicalmob = '' ;
this.lcervical = '' ;
this.lcervicallevel = '' ;
this.lcervicalsize = '' ;
this.lcervicalcons = '' ;
this.lcervicalmob = '' ;
this.raxillary = '' ;
this.raxillarylevel = '' ;
this.raxillarysize = '' ;
this.raxillarycons = '' ;
this.raxillarymob = '' ;
this.laxillary = '' ;
this.laxillarylevel = '' ;
this.laxillarysize = '' ;
this.laxillarycons = '' ;
this.laxillarymob = '' ;
this.ringuinal = '' ;
this.ringuinalsite = '' ;
this.ringuinalsize = '' ;
this.ringuinalcons = '' ;
this.ringuinalmob = '' ;
this.linguinal = '' ;
this.linguinalsite = '' ;
this.linguinalsize = '' ;
this.linguinalcons = '' ;
this.linguinalmob = '' ;
this.hnnotes = '' ;
this.ulnotes = '' ;
this.llnotes = '' ;
this.brestnotes = '' ;
}
retriveGeneralExamination()
{
  this.generalexaminationService.getGExamination(this.patientCode, this.storage.retrieve('stgcompCode'))
  .subscribe((data: GeneralExaminationModel) => {

    if (data.patientcode == null) {
      this. NewGeneralExaminationData();
      return;
    }

this.examdate         = formatDate(data.examdate, 'yyyy-MM-dd', 'en');
this.gcondition       = data.gcondition;
this.peform           = data.peform;
this.weight           = data.weight;
this.height           = data.height;
this.s_a              = data.s_a;
this.acs_a            = data.acs_a;
this.temp             = data.temp;
this.pulse            = data.pulse;
this.rhythm           = data.rhythm;
this.rhythms          = data.rhythms;
this.b_p              = data.b_p;
this.respirationrate  = data.respirationrate;
this.headneck         = data.headneck;
this.hncolour         = data.hncolour;
this.hnveins          = data.hnveins;
this.hnthyroid        = data.hnthyroid;
this.hnoralcavity     = data.hnoralcavity;
this.hnswelling       = data.hnswelling;
this.hnswellingsite   = data.hnswellingsite;
this.hnswellingsize   = data.hnswellingsize;
this.hncons           = data.hncons;
this.hnmob            = data.hnmob;
this.hnmention        = data.hnmention;
this.upperlimbs       = data.upperlimbs;
this.ulrswelling      = data.ulrswelling;
this.ulrswellsite     = data.ulrswellsite;
this.ulrswellsize     = data.ulrswellsize;
this.ulrcon           = data.ulrcon
this.ulrmob           = data.ulrmob
this.ulroedema        = data.ulroedema
this.ulrothers        = data.ulrothers
this.ullswelling      = data.ullswelling
this.ullswellsite     = data.ullswellsite
this.ullswellsize     = data.ullswellsize
this.ullcon           = data.ullcon
this.ullmob           = data.ullmob
this.ulloedema        = data.ulloedema
this.ullothers        = data.ullothers
this.lowerlimbs       = data.lowerlimbs
this.llrswelling      = data.llrswelling
this.llrswellsite     = data.llrswellsite
this.llrswellsize     = data.llrswellsize
this.llrcon           = data.llrcon
this.llrmob           = data.llrmob
this.llroedema        = data.llroedema
this.llrothers        = data.llrothers
this.lllswelling      = data.lllswelling
this.lllswellsite     = data.lllswellsite
this.lllswellsize     = data.lllswellsize
this.lllcon           = data.lllcon
this.lllmob           = data.lllmob
this.llloedema        = data.llloedema
this.lllothers        = data.lllothers
this.brest            = data.brest
this.bright           = data.bright
this.bleft            = data.bleft
this.chest            = data.chest
this.chestspes        = data.chestspes
this.abdomen          = data.abdomen
this.abdliver         = data.abdliver
this.abdspleen        = data.abdspleen
this.abdascities      = data.abdascities
this.abdothers        = data.abdothers
this.neurological     = data.neurological
this.neurspec         = data.neurspec
this.lymphadenopathy  = data.lymphadenopathy
this.rcervical        = data.rcervical
this.rcervicallevel   = data.rcervicallevel
this.rcervicalsize    = data.rcervicalsize
this.rcervicalcons    = data.rcervicalcons
this.rcervicalmob     = data.rcervicalmob
this.lcervical        = data.lcervical
this.lcervicallevel   = data.lcervicallevel
this.lcervicalsize    = data.lcervicalsize
this.lcervicalcons    = data.lcervicalcons
this.lcervicalmob     = data.lcervicalmob
this.raxillary        = data.raxillary
this.raxillarylevel   = data.raxillarylevel
this.raxillarysize    = data.raxillarysize
this.raxillarycons    = data.raxillarycons
this.raxillarymob     = data.raxillarymob
this.laxillary        = data.laxillary
this.laxillarylevel   = data.laxillarylevel
this.laxillarysize    = data.laxillarysize
this.laxillarycons    = data.laxillarycons
this.laxillarymob     = data.laxillarymob
this.ringuinal        = data.ringuinal
this.ringuinalsite    = data.ringuinalsite
this.ringuinalsize    = data.ringuinalsize
this.ringuinalcons    = data.ringuinalcons
this.ringuinalmob     = data.ringuinalmob
this.linguinal        = data.linguinal
this.linguinalsite    = data.linguinalsite
this.linguinalsize    = data.linguinalsize
this.linguinalcons    = data.linguinalcons
this.linguinalmob     = data.linguinalmob
this.hnnotes          = data.hnnotes
this.ulnotes          = data.ulnotes
this.llnotes          = data.llnotes
this.brestnotes       = data.brestnotes


  }
  );
}
submitGeneralExamination() {
  if (this.patientCode == null || this.patientCode == '') {
    return;
  }
  this.generalexamination.patientcode = this.patientCode;
  this.generalexamination.examdate         = formatDate(this.examdate, 'yyyy-MM-dd', 'en');
  this.generalexamination.gcondition       = this.gcondition;
  this.generalexamination.peform           = this.peform;
  this.generalexamination.weight           = this.weight.toString();
  this.generalexamination.height           = this.height.toString();
  this.generalexamination.s_a              = this.s_a;
  this.generalexamination.acs_a            = this.acs_a;
  this.generalexamination.temp             = this.temp.toString();
  this.generalexamination.pulse            = this.pulse;
  this.generalexamination.rhythm           = this.rhythm;
  this.generalexamination.rhythms          = this.rhythms;
  this.generalexamination.b_p              = this.b_p;
  this.generalexamination.respirationrate  = this.respirationrate;
  this.generalexamination.headneck         = this.headneck;
  this.generalexamination.hncolour         = this.hncolour;
  this.generalexamination.hnveins          = this.hnveins;
  this.generalexamination.hnthyroid        = this.hnthyroid;
  this.generalexamination.hnoralcavity     = this.hnoralcavity;
  this.generalexamination.hnswelling       = this.hnswelling;
  this.generalexamination.hnswellingsite   = this.hnswellingsite;
  this.generalexamination.hnswellingsize   = this.hnswellingsize;
  this.generalexamination.hncons           = this.hncons;
  this.generalexamination.hnmob            = this.hnmob;
  this.generalexamination.hnmention        = this.hnmention;
  this.generalexamination.upperlimbs       = this.upperlimbs;
  this.generalexamination.ulrswelling      = this.ulrswelling;
  this.generalexamination.ulrswellsite     = this.ulrswellsite;
  this.generalexamination.ulrswellsize     = this.ulrswellsize;
  this.generalexamination.ulrcon           = this.ulrcon
  this.generalexamination.ulrmob           = this.ulrmob
  this.generalexamination.ulroedema        = this.ulroedema
  this.generalexamination.ulrothers        = this.ulrothers
  this.generalexamination.ullswelling      = this.ullswelling
  this.generalexamination.ullswellsite     = this.ullswellsite
  this.generalexamination.ullswellsize     = this.ullswellsize
  this.generalexamination.ullcon           = this.ullcon
  this.generalexamination.ullmob           = this.ullmob
  this.generalexamination.ulloedema        = this.ulloedema
  this.generalexamination.ullothers        = this.ullothers
  this.generalexamination.lowerlimbs       = this.lowerlimbs
  this.generalexamination.llrswelling      = this.llrswelling
  this.generalexamination.llrswellsite     = this.llrswellsite
  this.generalexamination.llrswellsize     = this.llrswellsize
  this.generalexamination.llrcon           = this.llrcon
  this.generalexamination.llrmob           = this.llrmob
  this.generalexamination.llroedema        = this.llroedema
  this.generalexamination.llrothers        = this.llrothers
  this.generalexamination.lllswelling      = this.lllswelling
  this.generalexamination.lllswellsite     = this.lllswellsite
  this.generalexamination.lllswellsize     = this.lllswellsize
  this.generalexamination.lllcon           = this.lllcon
  this.generalexamination.lllmob           = this.lllmob
  this.generalexamination.llloedema        = this.llloedema
  this.generalexamination.lllothers        = this.lllothers
  this.generalexamination.brest            = this.brest
  this.generalexamination.bright           = this.bright
  this.generalexamination.bleft            = this.bleft
  this.generalexamination.chest            = this.chest
  this.generalexamination.chestspes        = this.chestspes
  this.generalexamination.abdomen          = this.abdomen
  this.generalexamination.abdliver         = this.abdliver
  this.generalexamination.abdspleen        = this.abdspleen
  this.generalexamination.abdascities      = this.abdascities
  this.generalexamination.abdothers        = this.abdothers
  this.generalexamination.neurological     = this.neurological
  this.generalexamination.neurspec         = this.neurspec
  this.generalexamination.lymphadenopathy  = this.lymphadenopathy
  this.generalexamination.rcervical        = this.rcervical
  this.generalexamination.rcervicallevel   = this.rcervicallevel
  this.generalexamination.rcervicalsize    = this.rcervicalsize
  this.generalexamination.rcervicalcons    = this.rcervicalcons
  this.generalexamination.rcervicalmob     = this.rcervicalmob
  this.generalexamination.lcervical        = this.lcervical
  this.generalexamination.lcervicallevel   = this.lcervicallevel
  this.generalexamination.lcervicalsize    = this.lcervicalsize
  this.generalexamination.lcervicalcons    = this.lcervicalcons
  this.generalexamination.lcervicalmob     = this.lcervicalmob
  this.generalexamination.raxillary        = this.raxillary
  this.generalexamination.raxillarylevel   = this.raxillarylevel
  this.generalexamination.raxillarysize    = this.raxillarysize
  this.generalexamination.raxillarycons    = this.raxillarycons
  this.generalexamination.raxillarymob     = this.raxillarymob
  this.generalexamination.laxillary        = this.laxillary
  this.generalexamination.laxillarylevel   = this.laxillarylevel
  this.generalexamination.laxillarysize    = this.laxillarysize
  this.generalexamination.laxillarycons    = this.laxillarycons
  this.generalexamination.laxillarymob     = this.laxillarymob
  this.generalexamination.ringuinal        = this.ringuinal
  this.generalexamination.ringuinalsite    = this.ringuinalsite
  this.generalexamination.ringuinalsize    = this.ringuinalsize
  this.generalexamination.ringuinalcons    = this.ringuinalcons
  this.generalexamination.ringuinalmob     = this.ringuinalmob
  this.generalexamination.linguinal        = this.linguinal
  this.generalexamination.linguinalsite    = this.linguinalsite
  this.generalexamination.linguinalsize    = this.linguinalsize
  this.generalexamination.linguinalcons    = this.linguinalcons
  this.generalexamination.linguinalmob     = this.linguinalmob
  this.generalexamination.hnnotes          = this.hnnotes
  this.generalexamination.ulnotes          = this.ulnotes
  this.generalexamination.llnotes          = this.llnotes
  this.generalexamination.userid = this.storage.retrieve('stguserId');
  this.generalexamination.modifieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  this.generalexamination.compcode = this.storage.retrieve('stgcompCode');

  this.generalexaminationService.AddGExamination(this.generalexamination).subscribe(data => {

  this.mesgSave();

  },

    error => { alert(error); }

  );

}
////**************** Follow Up Visits **********/
NewFollowUpData()
{

  //this.visverial = 1;
  this.visdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  this.vistype = '' ;
  this.visservice = 'Clinic Visit';
  this.visdiganosis = '' ;
  this.visdoctor = '' ;
  this.vislocation = '1' ;
  this.viscomplaint = '' ;
  this.visreqinvistigation = '' ;
  this.visweight = '' ;
  this.visbp = '' ;
  this.vispuls = '' ;
  this.visexamination = '' ;
  this.visdiseasestatus = '' ;
  this.vissite = '' ;
  this.visstage = '' ;
  this.visgrade = '' ;
  this.vist = '' ;
  this.visn = '' ;
  this.vism = '' ;
  this.didescription ='';
  this.visstatus = '' ;
  this.visdecision = '' ;
  this.vistttpolicy = '' ;
  this.visnextdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  this.visnextaction = '' ;
  this.visnotes = '' ;
  this.vispresenthistory = '' ;
  this.vissurgerytype = '' ;
  this.vissurgerynotes = '' ;
  this.visradiotype = '' ;
  this.visradiodose = '' ;
  this.visradionotes = '' ;
  this.vischemotype = '' ;
  this.vischemocycle = '' ;
  this.vischemonotes = '' ;
  this.vishormonaltype = '' ;
  this.vishormonalduration = '' ;
  this.vishormonalnotes = '' ;
  this.visotherstype = '' ;
  this.currentmedication = [];
  this.myimage = '';
  if (this.visverial == 1){ this.vistype = 'First Visit'}
  this.checkFirstVisit();
}
retriveFollowUp()
{
  this.followupvisitService.getFollowUpVisit(this.patientCode,this.visverial ,this.storage.retrieve('stgcompCode'))
  .subscribe((data: FollowUpVisitModel) => {
    if (data.patientcode == null) {
      this. NewFollowUpData();
      return;
    }
    this.visdate              = formatDate(data.visdate, 'yyyy-MM-dd', 'en');
    this.vistype              =  data.vistype;
    this.visservice           = data.visservice;
    this.visdiganosis         =  data.visdiganosis;
    this.visdoctor            =  data.visdoctor;
    this.vislocation          =  data.vislocation;
    this.viscomplaint         =  data.viscomplaint;
    this.visreqinvistigation  =  data.visreqinvistigation;
    this.visweight            =  data.visweight;
    this.visbp                =  data.visbp;
    this.vispuls              =  data.vispuls;
    this.visexamination       =  data.visexamination;
    this.visdiseasestatus     =  data.visdiseasestatus;
    this.vissite              =  data.vissite;
    this.visstage             =  data.visstage;
    this.visgrade             =  data.visgrade;
    this.vist                 =  data.vist;
    this.visn                 =  data.visn;
    this.vism                 =  data.vism;
    this.visstatus            =  data.visstatus;
    this.visdecision          =  data.visdecision;
    this.vistttpolicy         =  data.vistttpolicy;
    this.visnextdate          =  formatDate(data.visnextdate, 'yyyy-MM-dd', 'en');
    this.visnextaction        =  data.visnextaction;
    this.visnotes             =  data.visnotes;
    this.vispresenthistory =   data.vispresenthistory; ;
    this.vissurgerytype = data.vissurgerytype;
    this.vissurgerynotes = data.vissurgerynotes;
    this.visradiotype = data.visradiotype;
    this.visradiodose = data.visradiodose;
    this.visradionotes =data.visradionotes;
    this.vischemotype = data.vischemotype;
    this.vischemocycle =data.vischemocycle;
    this.vischemonotes =data.vischemonotes;
    this.vishormonaltype =data.vishormonaltype;
    this.vishormonalduration = data.vishormonalduration;
    this.vishormonalnotes = data.vishormonalnotes;
    this.visotherstype = data.visotherstype;
    if (this.vistttpolicy == 'Surgery'){ this.checkSurgery()};
    if (this.vistttpolicy == 'Radiotherapy'){ this.checkRadio()};
    if (this.vistttpolicy == 'Chemotherapy'){ this.checkChemo()};
    if (this.vistttpolicy == 'Hormonal Therapy'){ this.checkHormonal()};
    if (this.vistttpolicy == 'Others'){ this.checkOthers()};
    this.visreqinvistigation  =  data.visreqinvistigation;


  this.retriveCMedication();
  if (this.visverial == 1){ this.vistype = 'First Visit'}
  this.checkFirstVisit();
  }
  );
}
submitFollowUp() {

  if (this.patientCode == null || this.patientCode == '' || this.visdoctor == '') {
    return;
  }

  this.followupvisit.patientcode = this.patientCode;

  this.followupvisit.visverial                  = this.visverial;
  this.followupvisit.visdate                    = formatDate(this.visdate, 'yyyy-MM-dd', 'en');
  this.followupvisit.vistype                    = this.vistype;
  this.followupvisit.visservice                 = this.visservice;
  this.followupvisit.visdiganosis               = this.visdiganosis;
  this.followupvisit.visdoctor                  = this.visdoctor;
  this.followupvisit.vislocation                = this.vislocation;
  this.followupvisit.viscomplaint               = this.viscomplaint;
  this.followupvisit.visreqinvistigation        = this.visreqinvistigation;
  this.followupvisit.visweight                  = this.visweight;
  this.followupvisit.visbp                      = this.visbp;
  this.followupvisit.vispuls                    = this.vispuls;
  this.followupvisit.visexamination             = this.visexamination;
  this.followupvisit.visdiseasestatus           = this.visdiseasestatus;
  this.followupvisit.vissite                    = this.vissite;
  this.followupvisit.visstage                   = this.visstage;
  this.followupvisit.visgrade                   = this.visgrade;
  this.followupvisit.vist                       = this.vist;
  this.followupvisit.visn                       = this.visn;
  this.followupvisit.vism                       = this.vism;
  this.followupvisit.visstatus                  = this.visstatus;
  this.followupvisit.visdecision                = this.visdecision;
  this.followupvisit.vistttpolicy               = this.vistttpolicy;
  this.followupvisit.visnextdate                =formatDate(this.visnextdate, 'yyyy-MM-dd', 'en');
  this.followupvisit.visnextaction              = this.visnextaction;
  this.followupvisit.visnotes                   = this.visnotes;
  this.followupvisit.vispresenthistory      = this.vispresenthistory; ;
  this.followupvisit.vissurgerytype         = this.vissurgerytype;
  this.followupvisit.vissurgerynotes        = this.vissurgerynotes;
  this.followupvisit.visradiotype           = this.visradiotype;
  this.followupvisit.visradiodose           = this.visradiodose;
  this.followupvisit.visradionotes          = this.visradionotes;
  this.followupvisit.vischemotype           = this.vischemotype;
  this.followupvisit.vischemocycle          = this.vischemocycle;
  this.followupvisit.vischemonotes          = this.vischemonotes;
  this.followupvisit.vishormonaltype        = this.vishormonaltype;
  this.followupvisit.vishormonalduration    = this.vishormonalduration;
  this.followupvisit.vishormonalnotes       = this.vishormonalnotes;
  this.followupvisit.visotherstype          = this.visotherstype;


  this.followupvisit.userid = this.storage.retrieve('stguserId');
  this.followupvisit.modifieddate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  this.followupvisit.compcode = this.storage.retrieve('stgcompCode');

  this.followupvisitService.AddFollowUpVisit(this.followupvisit).subscribe(data => {

    this.mesgSave();

  },
    error => { alert(error);
                  }

  );
  this.submitDrugInteraction();
  this.submitDataBank();
}
retriveFollowUpLastSerial()
{

  this.followupvisitService.getFollowUpVisitLastSerial(this.patientCode,this.storage.retrieve('stgcompCode')).subscribe((data: FollowUpVisitModel) => {

    this.visverial            =  data.visverial;
    if (this.visverial == 1){ this.vistype = 'First Visit'}

    this.retriveFollowUp();
  }
  );

  //this.retriveFollowUp();
}
DelFollowUp() {

  this.followupvisitService
    .delFollowUpVisit(this.patientCode,this.visverial,this.storage.retrieve('stgcompCode'))
    .subscribe((data: FollowUpVisitModel) => {
      this.NewFollowUpData();


    });
  }
//////////////=============== Messages ===============///////////////////

  mesgSave() {
    Swal({
      title: 'Your work has been saved',
      type: 'success',
      showConfirmButton: false,

      timer: 1500,
    });
  }
  mesgDeleteDenographic() {

    Swal({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then(() => {
        this.DeleteDemographicData();
        Swal('Deleted!', 'Your record has been deleted.', 'success');

      },
      function (dismiss) {
        if (dismiss === 'cancel') {
          Swal('Cancelled', 'Your record is safe :)', 'error');
        }
      }
    );
  }
  mesgDeleteFollowupvisit() {

    Swal({
      title: 'Are you sure?',
      text: 'You will not be able to recover this record!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then(() => {
        this.DelFollowUp();
        Swal('Deleted!', 'Your record has been deleted.', 'success');

      },
      function (dismiss) {
        if (dismiss === 'cancel') {
          Swal('Cancelled', 'Your record is safe :)', 'error');
        }
      }
    );
  }

////================== Save All =========================================
SubmitAll()
{
  this.submitDataBank();
  this.submitDemographic();
  this.submitMedicalHistory();
  this.submitDisStarting();
  this.submitGeneralExamination();
  this.submitFollowUp();
}

 ////======================== Print All  ===============
 PrintAll(){

  this.storage.store('stgPar', this.patientCode);
  this.SubmitAll();
  this.route1.navigate(['report-vewier', this.ReportURL0]);
}
Attachments(){
  this.storage.store('stgPatientCode', this.patientCode);
}
printPrescription(){
  this.storage.store('stgPar', this.patientCode);
  this.storage.store('stgDate', this.visdate);

  this.route1.navigate(['report-vewier', this.ReportURL1]);
}
}
